import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import './_image-and-cards.scss';
document.querySelectorAll('[data-image-and-cards-swiper]').forEach(slider => {
  var section = slider.closest('.image-and-cards');
  var fill = section.querySelector('.image-and-cards__progress-fill');
  var next = section.querySelector('.image-and-cards__arrow--next');
  var prev = section.querySelector('.image-and-cards__arrow--prev');
  if (!slider) return;
  var swiper = new Swiper(slider, {
    modules: [Navigation],
    initialSlide: 1,
    slidesPerView: 1.25,
    centeredSlides: true,
    spaceBetween: 10,
    watchSlidesProgress: true,
    navigation: {
      nextEl: next,
      prevEl: prev
    },
    breakpoints: {
      769: {
        initialSlide: 2,
        slidesPerView: 3.5,
        centeredSlides: true,
        spaceBetween: 10
      }
    },
    on: {
      init(swiperInstance) {
        updateProgress(swiperInstance);
      },
      slideChange(swiperInstance) {
        updateProgress(swiperInstance);
      }
    }
  });
  function updateProgress(swiperInstance) {
    if (!fill) return;
    var total = swiperInstance.slides.length;
    var current = swiperInstance.realIndex + 1;
    var progress = current / total * 100;
    fill.style.width = "".concat(progress, "%");
  }
});